import { render, staticRenderFns } from "./TheFrontOfficeSnackbar.vue?vue&type=template&id=728c7abc&scoped=true"
import script from "./TheFrontOfficeSnackbar.vue?vue&type=script&lang=js"
export * from "./TheFrontOfficeSnackbar.vue?vue&type=script&lang=js"
import style0 from "./TheFrontOfficeSnackbar.vue?vue&type=style&index=0&id=728c7abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c7abc",
  null
  
)

export default component.exports